import { render, staticRenderFns } from "./ISearch.vue?vue&type=template&id=96e3b3f0&"
import script from "./ISearch.vue?vue&type=script&lang=ts&"
export * from "./ISearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports